import Serializer from "../../serializer";
import { TopicModel } from "./models";
import { JSONAPIDocument } from "json-api-serializer";
import { IMSTArray } from "mobx-state-tree";

export function deserializeTopics(data: JSONAPIDocument): IMSTArray<typeof TopicModel> {
  return Serializer.deserialize("topics", data);
}
